import { useCreateProductRecommendation } from '../modules/CreateProductRecommendation'
import { useDigitalProductRecommendation } from '../modules/DigitalProductRecommendation'
import { useHomeProductsRecommendation } from '../modules/HomeProductsRecommendation'
import { useIntegrationsRecommendation } from '../modules/IntegrationsRecommendation'

export const useProductsEmptyStateRecommendations = () => {
  const { homeProductsRecommendation } = useHomeProductsRecommendation(true)
  const { createProductRecommendation } = useCreateProductRecommendation()
  const { digitalProductRecommendation } = useDigitalProductRecommendation()
  const { integrationsRecommendation } = useIntegrationsRecommendation()

  const recommendations = [
    createProductRecommendation,
    homeProductsRecommendation,
    digitalProductRecommendation,
    integrationsRecommendation,
  ]

  const isLoadingRecommendations = recommendations.some(({ isLoading }) => isLoading)

  const enabledRecommendations = (() => {
    return recommendations.filter(({ enabled }) => enabled)
  })()

  return { recommendations: !isLoadingRecommendations ? enabledRecommendations : undefined }
}
